import src from "IMAGE";
export default { src, width: 166, height: 73, blurWidth: 0, blurHeight: 0};
